import { environment } from 'environments/environment';

export const NEW_DASHBOARD_ORG_IDS = [57, 300, 204];

export function isNewDashboardOrg(orgId: any): boolean {
    return NEW_DASHBOARD_ORG_IDS.includes(Number(orgId));
}

/**
 * Redirect to the new dashboard, replacing the current history entry.
 */
export function redirectToNewDashboard(): void {
    window.location.replace(environment.NEW_DASHBOARD_URL);
}

const REDIRECT_CONFIG_KEY = 'newDashboardRedirect';

/**
 * Persist the redirect config returned by the login API.
 */
export function storeRedirectConfig(config: {
    redirect: boolean;
    redirect_url: string;
}): void {
    localStorage.setItem(REDIRECT_CONFIG_KEY, JSON.stringify(config));
}

/**
 * Redirect using the stored redirect config, if there is one.
 * Returns true when a redirect was triggered.
 */
export function redirectIfStoredConfig(): boolean {
    try {
        const config = JSON.parse(localStorage.getItem(REDIRECT_CONFIG_KEY));
        if (config?.redirect && config.redirect_url) {
            window.location.replace(config.redirect_url);
            return true;
        }
    } catch {}
    return false;
}
